var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-container"},[_c('div',{staticClass:"scroll-content"},[_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"scroll-item"},[_vm._v(_vm._s(item))])}),_vm._l((_vm.list),function(item,index){return _c('div',{key:`a${index}`,staticClass:"scroll-item"},[_vm._v(_vm._s(item))])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }